var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 21,
    fill: "white",
    stroke: "#22E06C",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 23L27.5 28.1962L27.5 17.8038L35 23Z",
    fill: "#22E06C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23L18.5 17.8038L18.5 28.1962L11 23Z",
    fill: "#22E06C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandler);
export default __webpack_public_path__ + "static/media/handler.769f489a66709c16a4201050d8c13a80.svg";
export { ForwardRef as ReactComponent };